<div class="app-table-container">
  <table class="table app-table app-table-sticky mb-0">
    <thead>
      <tr>
        @for (col of columns; track col) {
          <th [ngStyle]="{'width': col.width || 'auto'}">
            <div class="d-flex flex-column gap-1">
              <div class="d-flex align-items-center gap-1">
                <span
                  [class.sortable]="col.sortable"
                  (click)="col.sortable ? onSort(col.field) : null"
                >{{ col.header }}</span>
                @if (col.sortable) {
                  <i [class]="getSortIcon(col.field)" class="ms-1 fs-9"></i>
                }
              </div>
              @if (col.filterable) {
                <div class="th-filter">
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    (input)="onFilter(col.field, $event)"
                    placeholder="Filter…"
                  />
                </div>
              }
            </div>
          </th>
        }
        @if (buttons && buttons.length > 0) {
          <th class="text-end" style="width: 80px">Actions</th>
        }
      </tr>
    </thead>
    <tbody>
      @for (item of filteredData; track item) {
        <tr>
          @for (col of columns; track col) {
            <td
              [ngStyle]="{'width': col.width || 'auto'}"
              [class.td-currency]="col.datatype === 'currency'"
              [class.td-number]="col.datatype === 'number'"
            >
              @if (col.datatype === 'date') {
                {{ item[col.field] | date:'dd-MM-yyyy' }}
              }
              @if (col.datatype === 'currency') {
                {{ item[col.field] | currency:'INR' }}
              }
              @if (col.datatype === 'transactionType') {
                {{ item[col.field] | transactionType }}
              }
              @if (!col.datatype) {
                {{ item[col.field] | defaultValue }}
              }
            </td>
          }
          @if (buttons && buttons.length > 0) {
            <td>
              <div class="td-actions">
                @for (btns of buttons; track btns) {
                  @if (btns.action === 'view') {
                    <span class="action-btn view" (click)="onClickExecute(item, btns)" title="View">
                      <i class="bi bi-eye"></i>
                    </span>
                  }
                  @if (btns.action === 'edit') {
                    <span class="action-btn edit" (click)="onClickExecute(item, btns)" title="Edit">
                      <i class="bi bi-pencil"></i>
                    </span>
                  }
                }
              </div>
            </td>
          }
        </tr>
      } @empty {
        <tr>
          <td [attr.colspan]="columns.length + (buttons?.length ? 1 : 0)">
            <div class="app-table-empty">
              <i class="bi bi-inbox"></i>
              <p>No records found</p>
            </div>
          </td>
        </tr>
      }
    </tbody>
  </table>
</div>
